import API from "../api/axiosInstance";

export const getUser = async () => {
  const response = await API.get("auth/me");
  return response.data;
};
